module.exports = __webpack_public_path__ + "img/download.48eda4c7.svg";